
import { FETCH_DossierComplet_REQUEST, FETCH_DossierComplet_SUCCESS, FETCH_DossierComplet_FAILURE } from './actionsTypes';

export const fetchDossierCompletRequest = (token,history) => ({
  type: FETCH_DossierComplet_REQUEST,
  payload: { token,history },
});

export const fetchDossierCompletSuccess = (dossierComplet) => ({
  type: FETCH_DossierComplet_SUCCESS,
  payload: { dossierComplet },
});

export const fetchDossierCompletFailure = (error) => ({
  type: FETCH_DossierComplet_FAILURE,
  payload: { error },
});

